import { render, staticRenderFns } from "./AlertSocialsModal.vue?vue&type=template&id=2f7dbbf1&"
import script from "./AlertSocialsModal.vue?vue&type=script&lang=js&"
export * from "./AlertSocialsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports